import LegalPage, { Address, MailLink, Section } from './LegalPage';

const Imprint = () => (
  <LegalPage
    title="Legal Notice"
    description="Legal notice (Impressum) for KZcomp.com."
    path="/imprint"
  >
    <Section title="Information pursuant to § 5 DDG">
      <Address />
      <p>
        Email: <MailLink />
      </p>
    </Section>

    <Section title="Consumer dispute resolution">
      <p>
        We are neither willing nor obliged to participate in dispute resolution proceedings before a
        consumer arbitration board.
      </p>
    </Section>
  </LegalPage>
);

export default Imprint;
